import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage } from '@/auth/pages/login';

const authLoginSearchSchema = z.object({
  redirectTo: z.string().optional()
});

export const Route = createFileRoute('/auth/login')({
  component: LoginRouteComponent,
  validateSearch: authLoginSearchSchema
});

/**
 * A component that renders the login page with a redirect parameter
 * extracted from the current route's query string.
 */
function LoginRouteComponent() {
  const { redirectTo } = Route.useSearch();

  return <LoginPage redirectTo={redirectTo} />;
}
